import {
  ProjectsOverviewStoreAction,
  ProjectsOverviewStoreKind,
  ProjectsOverviewStoreType,
} from './projectsOverviewStore.types';

export const INITIAL_PROJECTS_OVERVIEW = {
  projectList: [],
  numberOfItems: 0,
  numberOfPages: 0,
  averageRating: {
    overall: 0,
    relevance: 0,
    coherence: 0,
    effectivity: 0,
    efficiency: 0,
    impact: 0,
    sustainability: 0,
  },
  isError: false,
};

const projectsOverviewStore = (
  state: ProjectsOverviewStoreType,
  action: ProjectsOverviewStoreAction
): ProjectsOverviewStoreType => {
  switch (action.type) {
    case ProjectsOverviewStoreKind.INITIAL: {
      return { ...state, ...action.payload };
    }
    case ProjectsOverviewStoreKind.ERROR: {
      return { ...state, isError: true };
    }
    default:
      throw new Error();
  }
};

export default projectsOverviewStore;
